export * from './lib/apollo-client.module';
